import React from 'react';
import { motion } from 'framer-motion';

/**
 * LimHappyShop logo component. Loads /logo.png from the public folder.
 * Use `size` for height (px). Set `withText` to show "LimHappyShop" wordmark.
 */
export const Logo = ({ size = 40, withText = false, animated = true }) => {
  const img = (
    <img
      src="/logo.png"
      alt="LimHappyShop"
      style={{ height: size, width: 'auto', objectFit: 'contain', filter: 'drop-shadow(0 0 12px rgba(212,175,55,0.3))' }}
      data-testid="lh-logo"
    />
  );

  const content = animated ? (
    <motion.div
      whileHover={{ scale: 1.05, filter: 'drop-shadow(0 0 20px rgba(212,175,55,0.6))' }}
      transition={{ duration: 0.3 }}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}
    >
      {img}
      {withText && (
        <span style={{ fontFamily: "'Playfair Display', serif", color: '#F8FAF9', fontSize: size * 0.55, fontWeight: 300, letterSpacing: '0.05em' }}>
          LimHappy<span style={{ color: '#D4AF37' }}>Shop</span>
        </span>
      )}
    </motion.div>
  ) : (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      {img}
      {withText && (
        <span style={{ fontFamily: "'Playfair Display', serif", color: '#F8FAF9', fontSize: size * 0.55, fontWeight: 300, letterSpacing: '0.05em' }}>
          LimHappy<span style={{ color: '#D4AF37' }}>Shop</span>
        </span>
      )}
    </span>
  );

  return content;
};
